{
  "enums": {
    "claimStatus": {
      "draft": "Bản nháp",
      "submitted": "Đã nộp",
      "accepted": "Đã chấp nhận",
      "denied": "Bị từ chối",
      "paid": "Đã thanh toán"
    },
    "chargeStatus": {
      "pending": "Đang chờ",
      "unbilled": "Chưa lập hóa đơn",
      "posted": "Đã ghi sổ",
      "billed": "Đã lập hóa đơn",
      "adjusted": "Đã điều chỉnh",
      "voided": "Đã hủy"
    },
    "statementDelivery": {
      "print": "In",
      "email": "Email",
      "both": "In & Email",
      "mail": "Bưu điện"
    },
    "statementStatus": {
      "generated": "Đã tạo",
      "sent": "Đã gửi",
      "viewed": "Đã xem"
    },
    "denialStatus": {
      "new": "Mới",
      "inReview": "Đang xem xét",
      "appealing": "Đang kháng nghị",
      "resolved": "Đã giải quyết",
      "writtenOff": "Đã xóa nợ"
    },
    "denialPriority": {
      "low": "Thấp",
      "medium": "Trung bình",
      "high": "Cao"
    },
    "claimType": {
      "professional": "Chuyên môn",
      "institutional": "Cơ sở",
      "dental": "Nha khoa",
      "pharmacy": "Nhà thuốc"
    },
    "paymentMethod": {
      "cash": "Tiền mặt",
      "check": "Séc",
      "creditCard": "Thẻ tín dụng",
      "debitCard": "Thẻ ghi nợ",
      "bankTransfer": "Chuyển khoản ngân hàng",
      "digitalWallet": "Ví điện tử",
      "insurance": "Bảo hiểm"
    },
    "paymentSource": {
      "patient": "Bệnh nhân",
      "insurance": "Bảo hiểm",
      "thirdParty": "Bên thứ ba"
    }
  },
  "form": {
    "validation": {
      "patientIdRequired": "Bắt buộc nhập ID bệnh nhân",
      "encounterIdRequired": "Bắt buộc nhập ID lượt khám",
      "payerIdRequired": "Bắt buộc nhập ID bên chi trả",
      "chargeCodeRequired": "Bắt buộc nhập mã phí",
      "unitPriceRequired": "Bắt buộc nhập đơn giá",
      "amountRequired": "Bắt buộc nhập số tiền",
      "amountPositive": "Số tiền phải lớn hơn không",
      "chargeSelectionRequired": "Chọn ít nhất một khoản phí"
    }
  },
  "pages": {
    "statements": {
      "title": "Sao Kê Thanh Toán",
      "labels": {
        "dashboard": "Bảng điều khiển",
        "patient": "Bệnh nhân",
        "from": "Từ",
        "to": "Đến",
        "batchGenerate": "Tạo Hàng Loạt",
        "previewStatement": "Xem Trước Sao Kê",
        "generatePrint": "Tạo & In",
        "generateEmail": "Tạo & Gửi Email",
        "printEmail": "In & Email",
        "print": "In",
        "email": "Email"
      },
      "placeholders": {
        "searchPatient": "Tìm theo tên hoặc MRN..."
      },
      "aria": {
        "periodFrom": "Kỳ sao kê từ",
        "periodTo": "Kỳ sao kê đến"
      },
      "table": {
        "header": {
          "statementHistory": "Lịch Sử Sao Kê",
          "patient": "Bệnh nhân",
          "mrn": "MRN",
          "date": "Ngày",
          "amount": "Số tiền",
          "delivery": "Phương thức gửi",
          "status": "Trạng thái"
        },
        "preview": {
          "modal": "Xem Trước Sao Kê",
          "patientStatement": "Sao Kê Bệnh Nhân",
          "patient": "Bệnh nhân:",
          "mrn": "MRN:",
          "statementDate": "Ngày Sao Kê:",
          "period": "Kỳ:",
          "lineItemHeader": {
            "date": "Ngày",
            "description": "Mô tả",
            "charges": "Phí",
            "payments": "Thanh toán",
            "balance": "Số dư"
          },
          "openingBalance": "Số Dư Đầu Kỳ",
          "totals": "Tổng cộng",
          "amountDue": "Số Tiền Phải Trả"
        }
      },
      "states": {
        "generating": "Đang tạo...",
        "loading": "Đang tạo bản xem trước...",
        "noPatients": "Không tìm thấy bệnh nhân",
        "noStatementData": "Không có dữ liệu sao kê",
        "loadingHistory": "Đang tải lịch sử...",
        "noStatementsGenerated": "Chưa có sao kê nào được tạo",
        "selectedPatientId": "ID bệnh nhân đã chọn: {{id}}"
      },
      "toast": {
        "generated": "Đã tạo sao kê",
        "generatedError": "Không tạo được sao kê",
        "batchStarted": "Đã bắt đầu tạo hàng loạt: {{count}} sao kê đang chờ xử lý",
        "batchError": "Không bắt đầu được việc tạo hàng loạt"
      }
    },
    "claims": {
      "title": "Quản lý Yêu cầu Thanh toán",
      "labels": {
        "dashboard": "Bảng điều khiển",
        "createClaim": "Tạo Yêu cầu",
        "filters": "Bộ lọc",
        "submit": "Gửi",
        "appeal": "Khiếu nại",
        "denialReason": "Lý do Từ chối",
        "expandHint": "Mở rộng yêu cầu để xem các mục dòng trong trang yêu cầu chuyên dụng.",
        "cancel": "Hủy"
      },
      "filter": {
        "allStatuses": "Tất cả Trạng thái"
      },
      "placeholders": {
        "filterPayer": "Lọc theo người chi trả..."
      },
      "aria": {
        "claimDateFrom": "Ngày yêu cầu từ",
        "claimDateTo": "Ngày yêu cầu đến"
      },
      "table": {
        "header": {
          "claimNumber": "Yêu cầu #",
          "patient": "Bệnh nhân",
          "payer": "Người chi trả",
          "total": "Tổng",
          "status": "Trạng thái",
          "submitted": "Đã gửi",
          "actions": "Hành động"
        }
      },
      "modal": {
        "createClaim": "Tạo Yêu cầu từ Khoản phí",
        "patientId": "ID Bệnh nhân *",
        "payerId": "ID Người chi trả *",
        "selectCharges": "Chọn Khoản phí (đã chọn {{selected}})",
        "noBilledCharges": "Không có khoản phí chưa lập hóa đơn cho bệnh nhân này"
      },
      "states": {
        "loading": "Đang tải yêu cầu...",
        "noClaims": "Không tìm thấy yêu cầu",
        "creating": "Đang tạo..."
      },
      "toast": {
        "created": "Đã tạo yêu cầu",
        "createdError": "Không tạo được yêu cầu",
        "submitted": "Đã gửi yêu cầu",
        "submittedError": "Không gửi được yêu cầu",
        "resubmitted": "Đã gửi lại yêu cầu để khiếu nại",
        "resubmittedError": "Không gửi lại được yêu cầu",
        "patientPayerRequired": "Bệnh nhân và người chi trả là bắt buộc",
        "chargeRequired": "Chọn ít nhất một khoản phí"
      }
    },
    "charges": {
      "title": "Quản lý Khoản phí",
      "labels": {
        "dashboard": "Bảng điều khiển",
        "newCharge": "Khoản phí Mới",
        "totalChargesPeriod": "Tổng Khoản phí (Kỳ)",
        "filters": "Bộ lọc",
        "cancel": "Hủy"
      },
      "filter": {
        "allStatuses": "Tất cả Trạng thái"
      },
      "placeholders": {
        "filterPatient": "Lọc theo bệnh nhân..."
      },
      "aria": {
        "serviceDateFrom": "Ngày dịch vụ từ",
        "serviceDateTo": "Ngày dịch vụ đến"
      },
      "table": {
        "header": {
          "date": "Ngày",
          "patient": "Bệnh nhân",
          "encounter": "Lượt khám",
          "code": "Mã",
          "description": "Mô tả",
          "qty": "SL",
          "unitPrice": "Đơn giá",
          "total": "Tổng",
          "status": "Trạng thái",
          "actions": "Hành động"
        }
      },
      "actions": {
        "void": "Hủy bỏ"
      },
      "modal": {
        "voidCharge": "Hủy bỏ Khoản phí",
        "voidChargeConfirm": "Hủy bỏ khoản phí {{code}} - {{description}} ({{amount}})?",
        "reason": "Lý do *",
        "reasonPlaceholder": "Nhập lý do hủy bỏ..."
      },
      "states": {
        "loading": "Đang tải khoản phí...",
        "noCharges": "Không tìm thấy khoản phí cho kỳ này",
        "voiding": "Đang hủy bỏ..."
      },
      "toast": {
        "voided": "Đã hủy bỏ khoản phí",
        "voidedError": "Không hủy bỏ được khoản phí",
        "reasonRequired": "Lý do là bắt buộc"
      }
    },
    "payments": {
      "title": "Ghi nhận Thanh toán",
      "labels": {
        "dashboard": "Bảng điều khiển",
        "uploadEraEob": "Tải lên ERA/EOB",
        "postPayment": "Ghi nhận Thanh toán",
        "totalPaymentsPeriod": "Tổng Thanh toán (Kỳ)",
        "filters": "Bộ lọc",
        "cancel": "Hủy"
      },
      "placeholders": {
        "filterPatient": "Lọc theo bệnh nhân..."
      },
      "aria": {
        "paymentDateFrom": "Ngày thanh toán từ",
        "paymentDateTo": "Ngày thanh toán đến"
      },
      "table": {
        "header": {
          "date": "Ngày",
          "patient": "Bệnh nhân",
          "claimNumber": "Yêu cầu #",
          "amount": "Số tiền",
          "method": "Phương thức",
          "reference": "Tham chiếu",
          "postedBy": "Người ghi nhận"
        }
      },
      "modal": {
        "postPayment": "Ghi nhận Thanh toán",
        "patientId": "ID Bệnh nhân *",
        "claimId": "ID Yêu cầu (tùy chọn)",
        "claimIdHint": "Để trống cho khoản thanh toán chưa áp dụng",
        "amount": "Số tiền *",
        "method": "Phương thức *",
        "referenceNumber": "Số Tham chiếu",
        "referenceHint": "Số séc, ID giao dịch, v.v.",
        "notes": "Ghi chú"
      },
      "states": {
        "loading": "Đang tải thanh toán...",
        "noPayments": "Không tìm thấy thanh toán cho kỳ này",
        "posting": "Đang ghi nhận..."
      },
      "toast": {
        "posted": "Ghi nhận thanh toán thành công",
        "postedError": "Ghi nhận thanh toán thất bại",
        "patientAmountRequired": "Bắt buộc nhập bệnh nhân và số tiền",
        "validAmount": "Vui lòng nhập số tiền hợp lệ",
        "eraEobSoon": "Tải lên ERA/EOB sắp ra mắt"
      }
    },
    "chargeForm": {
      "title": "Tạo khoản phí",
      "labels": {
        "patientId": "ID Bệnh nhân *",
        "encounterId": "ID Lần khám *",
        "chargeCode": "Mã khoản phí *",
        "description": "Mô tả",
        "cptCode": "Mã CPT",
        "quantity": "Số lượng *",
        "unitPrice": "Đơn giá *"
      },
      "placeholders": {
        "chargeCode": "Tìm danh mục khoản phí...",
        "cptCode": "Tìm mã thủ thuật CPT..."
      },
      "buttons": {
        "cancel": "Hủy",
        "create": "Tạo khoản phí"
      },
      "toast": {
        "created": "Đã tạo khoản phí",
        "createdError": "Không thể tạo khoản phí"
      }
    },
    "claimForm": {
      "title": "Tạo Yêu cầu",
      "labels": {
        "patientId": "ID Bệnh nhân *",
        "encounterId": "ID Lần khám *",
        "payerId": "ID Người chi trả *",
        "claimType": "Loại Yêu cầu *",
        "diagnosisCodes": "Mã Chẩn đoán",
        "selectCharges": "Chọn Khoản phí (đã chọn {{selected}})",
        "notes": "Ghi chú"
      },
      "placeholders": {
        "diagnosisCodes": "Mã ICD-10 phân tách bằng dấu phẩy (vd. J06.9, R05)"
      },
      "buttons": {
        "cancel": "Hủy",
        "create": "Tạo Yêu cầu"
      },
      "toast": {
        "created": "Đã tạo yêu cầu",
        "createdError": "Không tạo được yêu cầu"
      }
    },
    "paymentForm": {
      "title": "Ghi nhận Thanh toán",
      "labels": {
        "patientId": "ID Bệnh nhân *",
        "claimId": "ID Yêu cầu",
        "amount": "Số tiền *",
        "method": "Phương thức Thanh toán *",
        "source": "Nguồn",
        "referenceNumber": "Số Tham chiếu",
        "notes": "Ghi chú"
      },
      "placeholders": {
        "claimId": "Tùy chọn — liên kết với yêu cầu",
        "reference": "Tham chiếu giao dịch hoặc séc"
      },
      "buttons": {
        "cancel": "Hủy",
        "post": "Ghi nhận Thanh toán"
      },
      "toast": {
        "recorded": "Đã ghi nhận thanh toán",
        "recordedError": "Ghi nhận thanh toán thất bại"
      }
    },
    "denials": {
      "title": "Quản lý Từ chối",
      "subtitle": "Theo dõi và quản lý các từ chối yêu cầu thanh toán",
      "placeholders": {
        "search": "Tìm yêu cầu..."
      },
      "filter": {
        "all": "Tất cả"
      },
      "checkbox": {
        "assignedToMe": "Được giao cho tôi"
      },
      "table": {
        "header": {
          "claimNumber": "Số yêu cầu",
          "patient": "Bệnh nhân",
          "denialCode": "Mã từ chối",
          "denialReason": "Lý do từ chối",
          "amount": "Số tiền",
          "daysRemaining": "Số ngày còn lại",
          "status": "Trạng thái",
          "assignedTo": "Được giao cho",
          "actions": "Thao tác"
        }
      },
      "actions": {
        "review": "Xem xét",
        "appeal": "Kháng nghị",
        "writeOff": "Xóa nợ",
        "cancel": "Hủy"
      },
      "modal": {
        "appealReason": "Lý do kháng nghị",
        "appealPlaceholder": "Mô tả lý do kháng nghị...",
        "submitAppeal": "Gửi kháng nghị",
        "writeOffTitle": "Xóa nợ Từ chối",
        "writeOffConfirm": "Bạn có chắc muốn xóa nợ yêu cầu {{claimNumber}} với số tiền {{amount}}? Hành động này không thể hoàn tác.",
        "writeOffButton": "Xóa nợ"
      },
      "states": {
        "loading": "Đang tải các từ chối...",
        "noDenials": "Không tìm thấy từ chối",
        "submitting": "Đang gửi..."
      },
      "toast": {
        "updateError": "Không thể cập nhật trạng thái từ chối",
        "movedToReview": "Yêu cầu {{claimNumber}} đã chuyển sang xem xét",
        "appealSubmitted": "Đã gửi kháng nghị",
        "writtenOff": "Yêu cầu {{claimNumber}} đã được xóa nợ"
      }
    }
  },
  "__review_denialReason": "Backend payer-authored — Phase 9, do not translate",
  "__review_denialCode": "Backend payer-authored — Phase 9, do not translate",
  "__review_chargeDescription": "Backend payer-authored — Phase 9, do not translate",
  "__review_chargeCode": "Backend payer-authored — Phase 9, do not translate"
}
